export const Div = ({ children, ...props }: { children: React.ReactNode }) => {
  return <div>{children}</div>;
};
